import { Input, InputLabel } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { color, padding } from '@mui/system';
import axios from 'axios';

const PARSHIOT = ['בראשית', 'נח', 'לך לך', 'וירא', 'חיי שרה', 'תולדות', 'ויצא', 'וישלח',
  'וישב', 'מקץ', 'ויגש', 'ויחי', 'שמות', 'וארא', 'בא', 'בשלח', 'יתרו', 'משפטים', 'תרומה',
  'תצוה', 'כי תשא', 'ויקהל', 'פקודי', 'ויקרא', 'צו', 'שמיני', 'תזריע', 'מצורע', 'אחרי מות',
  'קדושים', 'אמור', 'בהר', 'בחוקתי', 'במדבר', 'נשא', 'בהעלותך', 'שלח', 'קרח', 'חקת', 'בלק',
  'פנחס', 'מטות', 'מסעי', 'דברים', 'ואתחנן', 'עקב', 'ראה', 'שופטים', 'כי תצא', 'כי תבוא',
  'נצבים', 'וילך', 'האזינו', 'וזאת הברכה'];

var ORDERED_MONTHES = ['תשרי', 'מרחשון', 'כסלו', 'טבת', 'שבט', 'אדר א', 'אדר', 'ניסן', 'אייר', 'סיון', 'תמוז', 'אב', 'אלול'];

const useStyles = makeStyles((theme) => ({
  root: {
    // textAlign: '',
  },
  formControl: {
    margin:'10px',
    textAlign: 'unset',
  },
  searchWrapper: {
    boxShadow: '0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%)',
    '&:hover': {
      boxShadow: '0px 2px 4px -1px rgb(0 0 0 / 20%), 0px 4px 5px 0px rgb(0 0 0 / 14%), 0px 1px 10px 0px rgb(0 0 0 / 12%);,'
    },
    borderRadius: '4px',
    border: '1px solid #3f51b5',
    overflow: 'hidden',
  },
  search: {
    position: 'relative',
    width: '100%',
    // [theme.breakpoints.up('sm')]: {
    //   width: '100%',
    // },
  },
  searchIcon: {
    padding: '10px',
    height: '100%',
    position: 'absolute',
    left: 0,
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  // inputRoot: {
  //   color: 'inherit',
  // },
  // inputInput: {
  //   padding: '10px',
  //   // paddingLeft: `calc(1em + 100px)`,
  //  transition: 'width',
  //   width: '100%',
  // },
}));

const customStyles = {
  option: (provided, state) => ({
    ...provided,
    padding: 5,
  }),
  control: (provided, state) => ({
    ...provided,
    backgroundColor: '#001690',
  }),
  singleValue: (provided, state) => ({
    ...provided,
    color: '#ffffff',
  }),
}

function filterSelected(selectedSubjects) {
  const obj = {};
  for (const key in selectedSubjects) {
    if (selectedSubjects[key].value !== '' && selectedSubjects[key].value !== undefined) {
      obj[key] = selectedSubjects[key].value
    }
  }
  return obj;
}

function createQuery(field, value, selectedSubjects, page) {
  const selected = filterSelected(selectedSubjects);
  let query = '';
  query += `page=${page}&field=${field}&`
    query += `value=${value}&`
  for (const key in selected) {
    query += `${key}=${selected[key]}&`
  }
  return query.slice(0, query.length - 1);
}

function parseQueries() {
  let page, field, value;
  const selected = {}
  let query = window.location.search;
  query = query.replace('?', '').split('&');
  query.forEach(el => {
    const arr = el.split('=');
    if (arr[0] === 'page') {
      page = +arr[1] + 1;
    } else if (arr[0] === 'value') {
      value = decodeURI(arr[1]);
    } else if (arr[0] === 'field') {
      field = arr[1];
    } else {
      selected[arr[0]] = {value: decodeURI(arr[1]), lable: decodeURI(arr[1])};
    }
  });
  return { page, field, value, selected }
}

async function searchSicha(query) {
  const { data } = await axios.get(`${process.env.REACT_APP_API_ENDPOINT}/daily-sicha/search-sicha${query}`);
  return data;
}

async function getAbstractsBySubject(query) {
  const { data } = await axios.get(`${process.env.REACT_APP_API_ENDPOINT}/daily-sicha/get-search-abstracts${query}`);
  return data;
}

async function getSubjects() {
  const { data } = await axios.get(`${process.env.REACT_APP_API_ENDPOINT}/daily-sicha/get-subjects`);
  return data[0];
}

async function filterSubjects(field, subField, value) {
  const { data } = await axios.post(`${process.env.REACT_APP_API_ENDPOINT}/daily-sicha/filter-subjects`, { field, subField, value });
  if (data[0] === '') {
    data.splice(0, 1, 'ללא')
  } else {
    data.unshift('ללא');
  }
  return data;
}



export { useStyles, searchSicha, getAbstractsBySubject, getSubjects, filterSubjects, createQuery, parseQueries, customStyles, PARSHIOT, ORDERED_MONTHES }